import { gql } from '@apollo/client';
import PostFragment from '../fragments/post';

export const SEARCH_CONTENT_QUERY = gql`
  query searcContenthQuery(
    $offset: Int
    $perPage: Int
    $slug: String
    $postCategory: [String]
    $videoType: [String]
    $termsTaxonomy: String
    $termsSlug: String
    $projectSlug: String
  ) {
    posts: posts(
      request: {
        slug: $slug
        projectSlug: $projectSlug
        terms: { taxonomy: $termsTaxonomy, slug: $termsSlug }
        offset: $offset
        perPage: $perPage
        custom: { postCategory: $postCategory, videoType: $videoType }
      }
    ) {
      totalCount
      totalPage
      items {
        ...PostFields
      }
    }
  }
  ${PostFragment}
`;
